import { createFileRoute } from '@tanstack/react-router';
import EmergencyStatus from '~/containers/EmergencyStatus';

export const Route = createFileRoute('/emergency-status')({
  component: EmergencyStatus,
});
